'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconWaveform, iconWaveformTag } from '@ni/nimble-components/dist/esm/icons/waveform';
import { wrap } from '../../utilities/react-wrapper';

export type { IconWaveform };
export { iconWaveformTag };
export const NimbleIconWaveform = wrap(IconWaveform);